import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import faqData from '../../../assets/jsondata/faq-data.json';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnInit {

  constructor(private apiService: ApiService) { }
  faqAndOverview;
  selectedSectionDetail: any;
  accountCategory: string;
  accountType: string;
  showFaqs: boolean = false;

  ngOnInit(): void {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.Type;
    this.faqAndOverview = faqData;

    // this.selectedSectionDetail = this.faqAndOverview[0];
    this.selectedSectionDetail = this.faqAndOverview[1].sections[0];
  }

  openSectionDetail(sectionDetail: any) {
    this.selectedSectionDetail = sectionDetail;
  }

  onCloseFaqs() {
    this.showFaqs = false;
  }
}
